<div class="order-summary-body-row">
  <div class="order-body-item">
    <div class="order-summary-detail">
      <div class="order-image">
        <img
          src="{{
            event.media[0]?.mediaFile?.location ||
              'https://asylumtixmedia.sfo3.digitaloceanspaces.com/asylumTix/default_images/ticket_logo.jpg'
          }} "
          alt=""
        />
      </div>
      <div class="order-detail-content">
        <h2>{{ event.eventName }}</h2>
        <h6 class="flex items-center text-sm">
          <tix-icon svgIcon="clock-icon-solid"></tix-icon>
          {{ event.date | date: 'E' | uppercase }}
          <span>
            &nbsp;• {{ event.date | date: 'MMM d' | uppercase }}
            <ng-container *ngIf="event.startTime">
              •
              {{ event.date + ' ' + event.startTime | date: 'shortTime' }}
            </ng-container>
          </span>
        </h6>
      </div>
    </div>
  </div>
  <div
    class="order-body-item"
    *ngIf="orderSelectionInitialized; else initialHoldValidationPerforming"
  >
    <ng-container *ngFor="let ticket of tickets">
      <div
        *ngIf="
          !ticket.salesChannel ||
          ticket.salesChannel.toLowerCase() === 'both' ||
          ticket.salesChannel.toLowerCase() === 'online'
        "
        [ngClass]="{
          'order-body-inner-row': true,
          'cursor-not-allowed opacity-40':
            itemIsSoldOut(ticket.ticketConfigId) ||
            itemIsExpired(ticket.ticketConfigId) ||
            itemComingSoon(ticket.ticketConfigId)
        }"
      >
        <div class="order-body-inner-item">
          <label class="mobile-label">Name</label>
          <h5
            class="md:w-full md:overflow-hidden md:text-ellipsis md:whitespace-nowrap md:!block"
            matTooltipClass="whitespace-pre-line"
            [matTooltip]="
              'Name: ' + ticket.name + '\n' + 'Section: ' + ticket.section
            "
          >
            {{ ticket.name }}
          </h5>
        </div>
        <div class="order-body-inner-item">
          <label class="mobile-label">Type</label>
          <h5>{{ ticket.ticketType }}</h5>
        </div>
        <!-- <div class="order-body-inner-item">
        <label class="mobile-label">Srv Fee</label>
        <h5>
          {{
            getTotal(ticket.platformFee, ticket.processingFee, ticket.venueFee)
          }}
        </h5>
      </div> -->
        <!-- <div class="order-body-inner-item">
        <label class="mobile-label">Remaining Tickets</label>
        <h5>{{ getRemainingTickets(ticket) - ticket.ticketQty }}</h5>
      </div> -->
        <div class="order-body-inner-item">
          <div class="ticket-qty">
            <ng-container
              *ngIf="
                !itemIsSoldOut(ticket.ticketConfigId) &&
                  !itemIsExpired(ticket.ticketConfigId) &&
                  !itemComingSoon(ticket.ticketConfigId);
                else soldOutOrExpiredOrComingSoon
              "
            >
              <button
                type="button"
                class="ticket-qty-btn-minus"
                (click)="itemDecrementClick(ticket.ticketConfigId)"
                [disabled]="
                  !orderStateManager.canDecrementQuantity(ticket.ticketConfigId)
                "
              >
                -
              </button>
              <label>{{
                orderStateManager.getQuantitySelectedForItem(
                  ticket.ticketConfigId
                )
              }}</label>
              <button
                type="button"
                [ngClass]="{
                  'ticket-qty-btn-plus': true,
                  'opacity-70 cursor-not-allowed':
                    ticket.ticketQty >= getMaxQty(ticket.ticketConfigId)
                }"
                (click)="itemIncrementClick(ticket.ticketConfigId)"
                [disabled]="
                  !orderStateManager.canIncrementQuantity(ticket.ticketConfigId)
                "
              >
                +
              </button>
            </ng-container>
            <ng-template #soldOutOrExpiredOrComingSoon>
              <ng-container
                *ngIf="
                  itemIsSoldOut(ticket.ticketConfigId) &&
                  !itemIsExpired(ticket.ticketConfigId) &&
                  !itemComingSoon(ticket.ticketConfigId)
                "
              >
                <h4 class="!text-red-500">SOLD OUT</h4>
              </ng-container>
              <ng-container
                *ngIf="
                  itemComingSoon(ticket.ticketConfigId) &&
                  !itemIsExpired(ticket.ticketConfigId)
                "
              >
                <h4 class="!text-green-500">COMING SOON</h4>
              </ng-container>
              <ng-container *ngIf="itemIsExpired(ticket.ticketConfigId)">
                <h4 class="!text-red-500">EXPIRED</h4>
              </ng-container>
            </ng-template>
          </div>
        </div>
        <!-- <div class="order-body-inner-item delete-icon-item hidden md:block">
          <a (click)="delete(ticket, event.eventInstanceId)">
            <tix-icon svgIcon="table-trash"></tix-icon>
          </a>
        </div> -->
      </div>
    </ng-container>
  </div>

  <ng-template #initialHoldValidationPerforming>
    <div class="flex items-center justify-center my-6 w-full">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</div>
<h3 class="errorMessage">{{ errorMessage }}</h3>
